var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(3.1311 10.3906)",
    d: "M23.75 0.02625L23.75 15.235L0 15.235L0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(0.631104 0.625)",
    d: "M26.25 0L2.5 0L0 5L28.75 5L26.25 0L26.25 0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(0.631104 5.625)",
    d: "M28.75 1.25C28.75 3.3225 27.0712 5 25 5C23.9675 5 23.1787 4.425 22.5 3.75C21.615 5.15625 19.9087 6.25 18.125 6.25C16.6313 6.25 15.2913 5.59 14.375 4.55C13.46 5.59 12.12 6.25 10.625 6.25C8.84125 6.25 7.135 5.15625 6.25 3.75C5.5725 4.425 4.7825 5 3.75 5C1.67875 5 0 3.3225 0 1.25L0 0L28.75 0L28.75 1.25L28.75 1.25Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(6.8811 0.625)",
    d: "M0 8.75L0 5L1.25 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(15.0061 0.62561)",
    d: "M0 9.5575L0 5L0 0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(21.8811 0.625)",
    d: "M1.25 8.75L1.25 5L0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon_store.2a38801cf07a9f21107b33930f6d0c2f.svg";
export { ForwardRef as ReactComponent };